const getUrlParam = (param: string) => {
  return new URLSearchParams(window.location.search).get(param);
};
export default getUrlParam;
